document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.p7-video-gallery').forEach(gallery => {
    const galleryTopEl = gallery.querySelector('.gallery-top');
    const galleryThumbsEl = gallery.querySelector('.gallery-video-thumbs');
    if (!galleryTopEl || !galleryThumbsEl) return;

    const thumbsPerView = parseInt(gallery.dataset.thumbs) || 3;
    const direction = gallery.dataset.direction || 'horizontal';

    // Initialize thumbs Swiper
    const galleryThumbs = new Swiper(galleryThumbsEl, {
      spaceBetween: 8,
      slidesPerView: 2,
      watchSlidesProgress: true,
      direction: 'horizontal',
      freeMode: true,
      mousewheel: true,
      breakpoints: {
        768: {
          direction: direction,
          slidesPerView: Math.min(thumbsPerView, 3)
        },
      },
    });

    // Initialize main Swiper
    const galleryTop = new Swiper(galleryTopEl, {
      navigation: {
        nextEl: gallery.querySelector('.swiper-button-video-next'),
        prevEl: gallery.querySelector('.swiper-button-video-prev'),
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });

    function updateActiveThumb() {
      galleryThumbsEl.querySelectorAll('.swiper-slide').forEach((slide, idx) => {
        const isActive = idx === galleryTop.activeIndex;

        slide.classList.toggle('swiper-slide-thumb-active', isActive);

        const checkIcon = slide.querySelector('.thumb-active-icon');
        if (checkIcon) checkIcon.style.display = isActive ? 'flex' : 'none';

        // const title = slide.querySelector('.thumb-title-overlay');
        // if (title) title.style.opacity = isActive ? '1' : '0';

        const pauseIcon = slide.querySelector('.thumb-pause-icon');
        if (pauseIcon) pauseIcon.style.display = isActive ? 'flex' : 'none';

        const playIcon = slide.querySelector('.thumb-play-icon');
        if (playIcon) playIcon.style.display = isActive ? 'none' : 'flex';
      });

      const iframes = gallery.querySelectorAll('.gallery-top iframe');

      iframes.forEach((iframe) => {
        const src = iframe.src;
        iframe.src = src;
      });
    }

    updateActiveThumb();

    galleryTop.on('slideChange', updateActiveThumb);

    galleryThumbsEl.querySelectorAll('.swiper-slide').forEach((slide, idx) => {
      slide.addEventListener('click', () => {
        galleryTop.slideTo(idx);
      });
    });
  });
});
